module.exports = __webpack_public_path__ + "static/media/facePlaceholder.56063c60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/facePlaceholder.jpg
// module id = 897
// module chunks = 0